/* eslint-disable camelcase */
import { createSelector } from 'reselect';
export const selectCustomise = (state) => state.customise.present;
export const selectBuilder = (state) => state.builder.present;
export const selectForm = (state) => state.form;

export const selectCtrlIdLabelMap = createSelector(
  [selectBuilder, selectCustomise, selectForm],
  (builder, customise, form) => {
    const inCustomise = Object.keys(customise?.labelPipedCtrlLabelsMap ?? {}).length;
    const inBuilder = Object.keys(builder?.labelPipedCtrlLabelsMap ?? {}).length;
    const inForm = Object.keys(form.valuePipedCtrlLabelsMap).length;
    
    if (inCustomise) return customise?.labelPipedCtrlLabelsMap ?? {};
    if (inBuilder) return builder?.labelPipedCtrlLabelsMap ?? {};
    if (inForm) return form.valuePipedCtrlLabelsMap;
  }
);